module.exports = __webpack_public_path__ + "static/media/favicon.f70e284b.png";